export const SET_STRATEGIC_PLANS = "STRATEGIC_PLANS/SET_STRATEGIC_PLANS";
export const SET_STRATEGIC_PLAN = "STRATEGIC_PLANS/SET_STRATEGIC_PLAN";
export const SET_PAGINATION = "STRATEGIC_PLANS/SET_PAGINATION";
export const SET_TREE_PLAN_STRUCTURE = "STRATEGIC_PLANS/SET_TREE_PLAN_STRUCTURE";
